export const AI_AGENT_TAG = 'agent';
export const AI_AGENT_APPLICATION_NAME = 'lightdash-ai';
export const AI_AGENT_SESSION_SETTING = 'lightdash.agent';
export var AiAgentMarkerLevel;
(function (AiAgentMarkerLevel) {
    AiAgentMarkerLevel["VERIFIED_SESSION"] = "verified_session";
    AiAgentMarkerLevel["REQUEST_BOUND"] = "request_bound";
    AiAgentMarkerLevel["IDENTIFY_ONLY"] = "identify_only";
    AiAgentMarkerLevel["NONE"] = "none";
})(AiAgentMarkerLevel || (AiAgentMarkerLevel = {}));
export const AI_PRINCIPAL_QUERY_TAG = 'ai_principal';
export var AgentIdentityConnectEntryPoint;
(function (AgentIdentityConnectEntryPoint) {
    AgentIdentityConnectEntryPoint["CHAT_CARD"] = "chat_card";
    AgentIdentityConnectEntryPoint["MY_WAREHOUSE_CONNECTIONS"] = "my_warehouse_connections";
    AgentIdentityConnectEntryPoint["MCP_CONNECT_LINK"] = "mcp_connect_link";
    AgentIdentityConnectEntryPoint["CLI"] = "cli";
    AgentIdentityConnectEntryPoint["MCP_CONSENT"] = "mcp_consent";
    AgentIdentityConnectEntryPoint["OAUTH_CONSENT"] = "oauth_consent";
    AgentIdentityConnectEntryPoint["SLACK_LINK"] = "slack_link";
    AgentIdentityConnectEntryPoint["UNKNOWN"] = "unknown";
})(AgentIdentityConnectEntryPoint || (AgentIdentityConnectEntryPoint = {}));
export var AgentIdentityConnectFailureReason;
(function (AgentIdentityConnectFailureReason) {
    AgentIdentityConnectFailureReason["ACCESS_DENIED"] = "access_denied";
    AgentIdentityConnectFailureReason["OAUTH_ERROR"] = "oauth_error";
    AgentIdentityConnectFailureReason["STATE_MISMATCH"] = "state_mismatch";
    AgentIdentityConnectFailureReason["TOKEN_EXCHANGE_FAILED"] = "token_exchange_failed";
    AgentIdentityConnectFailureReason["NO_REFRESH_TOKEN"] = "no_refresh_token";
    AgentIdentityConnectFailureReason["NOT_AGENT_SESSION"] = "not_agent_session";
    AgentIdentityConnectFailureReason["SESSION_CHECK_FAILED"] = "session_check_failed";
    AgentIdentityConnectFailureReason["LICENSE_REQUIRED"] = "license_required";
    AgentIdentityConnectFailureReason["ORGANIZATION_REQUIRED"] = "organization_required";
    AgentIdentityConnectFailureReason["NOT_CONFIGURED"] = "not_configured";
    AgentIdentityConnectFailureReason["CREDENTIAL_SAVE_FAILED"] = "credential_save_failed";
    AgentIdentityConnectFailureReason["SIGN_IN_FAILED"] = "sign_in_failed";
})(AgentIdentityConnectFailureReason || (AgentIdentityConnectFailureReason = {}));
export var AiAccessRefusalReason;
(function (AiAccessRefusalReason) {
    AiAccessRefusalReason["RESULT_NOT_AGENT_PRODUCED"] = "result_not_agent_produced";
    AiAccessRefusalReason["PRINCIPAL_FAILED"] = "principal_failed";
    AiAccessRefusalReason["NEEDS_SIGN_IN"] = "needs_sign_in";
    AiAccessRefusalReason["SIGN_IN_EXPIRED"] = "sign_in_expired";
    AiAccessRefusalReason["WAREHOUSE_NOT_SUPPORTED"] = "warehouse_not_supported";
    AiAccessRefusalReason["SERVICE_ACCOUNT"] = "service_account";
    AiAccessRefusalReason["EMBED_NOT_SUPPORTED"] = "embed_not_supported";
})(AiAccessRefusalReason || (AiAccessRefusalReason = {}));
export var AiAccessRefusalAction;
(function (AiAccessRefusalAction) {
    AiAccessRefusalAction["SIGN_IN"] = "sign_in";
    AiAccessRefusalAction["ASK_ADMIN"] = "ask_admin";
})(AiAccessRefusalAction || (AiAccessRefusalAction = {}));
export const AI_ACCESS_REFUSED_CODE = 'ai_access_refused';
export const getAiAccessRefusalMessage = (reason) => {
    switch (reason) {
        case AiAccessRefusalReason.RESULT_NOT_AGENT_PRODUCED:
            return 'AI cannot use these results because your current agent connection did not produce them. Run the query again through your agent.';
        case AiAccessRefusalReason.PRINCIPAL_FAILED:
            return 'The last check of your AI principal failed. Ask an admin to review it.';
        case AiAccessRefusalReason.SIGN_IN_EXPIRED:
            return 'Your agent connection expired. Connect again.';
        case AiAccessRefusalReason.NEEDS_SIGN_IN:
            return 'Connect your agent to the warehouse once so it can run as you.';
        case AiAccessRefusalReason.WAREHOUSE_NOT_SUPPORTED:
            return 'AI principals are not available for this warehouse yet.';
        case AiAccessRefusalReason.EMBED_NOT_SUPPORTED:
            return 'AI access runs as a signed-in person. Embedded viewers cannot use it on this connection.';
        case AiAccessRefusalReason.SERVICE_ACCOUNT:
            return 'AI access runs as a person. Service accounts cannot use it on this connection.';
        default: {
            const exhaustive = reason;
            return String(exhaustive);
        }
    }
};
export const getAiAccessRefusalAction = (reason) => {
    switch (reason) {
        case AiAccessRefusalReason.SIGN_IN_EXPIRED:
        case AiAccessRefusalReason.NEEDS_SIGN_IN:
            return AiAccessRefusalAction.SIGN_IN;
        case AiAccessRefusalReason.PRINCIPAL_FAILED:
            return AiAccessRefusalAction.ASK_ADMIN;
        case AiAccessRefusalReason.RESULT_NOT_AGENT_PRODUCED:
        case AiAccessRefusalReason.EMBED_NOT_SUPPORTED:
        case AiAccessRefusalReason.WAREHOUSE_NOT_SUPPORTED:
        case AiAccessRefusalReason.SERVICE_ACCOUNT:
            return null;
        default: {
            const exhaustive = reason;
            return exhaustive;
        }
    }
};
export const isAiAccessRefusal = (value) => typeof value === 'object' &&
    value !== null &&
    value.code === AI_ACCESS_REFUSED_CODE &&
    typeof value.message === 'string';
//# sourceMappingURL=aiPrincipal.js.map